import { ProgramAccredited } from '@bforms-web/common';

import { ACCREDITED_EDIT_ROUTE, ACCREDITED_REGISTER_ROUTE } from '../../constants';
import Table, { TableProps } from '../Table';
import { KeysLocalStorage } from '../../enums/keys-localstorage';

function formatCNPJ(cnpj: string): string {
  return cnpj.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, "$1.$2.$3/$4-$5");
}

const columns = [
  {
    key: 'accrediteCorporateReason',
    label: 'Razão Social',
    render: (value: any, accrediteCorporateReason: ProgramAccredited) => {
      return accrediteCorporateReason.accredited.corporateReason;
    }
  },
  {
    key: 'accrediteFantasyName',
    label: 'Nome Fantasia',
    render: (value: any, accrediteCorporateReason: ProgramAccredited) => {
      return accrediteCorporateReason.accredited.fantasyName;
    }
  },
  {
    key: 'accrediteCNPJ',
    label: 'CNPJ',
    render: (value: any, accrediteCNPJ: ProgramAccredited) => {
      return formatCNPJ(accrediteCNPJ.accredited.CNPJ);
    }
  },
  {
    key: 'programName',
    label: 'Programa',
    render: (value: any, programName: ProgramAccredited) => {
      return programName.program.name;
    },
  }
];

export type AccreditedTableProps = {
  data: ProgramAccredited[];
} & Pick<
TableProps,
'count'
| 'onChangePage'
| 'onChangeRows'
| 'onRemove'
| 'onSearch'
| 'page'
| 'rowsPerPage'
>;

function saveAccreditedLocalStorage(accredited: ProgramAccredited) {
  localStorage.setItem(KeysLocalStorage.DATA_ACCREDITED, JSON.stringify(accredited));
}

export default function AccreditedTable({ 
  data, 
  ...props
 }: AccreditedTableProps): JSX.Element {
  return (
    <Table
      columns={columns}
      data={data}
      title={'Clínicas credenciadas'}
      size="small"
      canAdd
      addRoute={ACCREDITED_REGISTER_ROUTE}
      canEdit
      editRoute={ACCREDITED_EDIT_ROUTE}
      editOnClick={saveAccreditedLocalStorage}
      canRemove
      {...props}
    />
  );
}